import { fetchAuthSession } from "aws-amplify/auth";

/**
 * Helper function to get current ID token from Amplify session
 * Returns null if no valid session exists
 */
export async function getAmplifyIdToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();

    return session.tokens?.idToken?.toString() || null;
  } catch (error) {
    console.error("Error fetching Amplify session:", error);
    return null;
  }
}

/**
 * Helper function to check if user is authenticated
 */
export async function isAuthenticated(): Promise<boolean> {
  try {
    const session = await fetchAuthSession();

    return !!(session.tokens && session.tokens.idToken);
  } catch (error) {
    return false;
  }
}
